











import { Component, Prop, Vue } from 'vue-property-decorator';
import { EntityStatus, FeedTank, Tank, Vat, WaterMeter, WaterMonitor, WaterTank } from '@/api';
import InformationRow from '@/components/display/information-row.vue';

@Component({
	components: { InformationRow },
})
export default class LiveAtRow extends Vue {
	@Prop({ required: true })
	public entity!: Vat | Tank | WaterMeter | WaterTank | WaterMonitor | FeedTank;

	private get isLive(): boolean {
		return this.entity?.status === EntityStatus.Live;
	}

	private get liveAt(): string | null | undefined {
		return this.entity?.liveAtDate ?? this.entity?.liveAt ?? this.entity?.createdAt;
	}
}
